import { intersection } from 'lodash';

import { featureFlagsService, inMemoryJWTService } from '~services';

export function checkEnabledFeatureFlag(key: string) {
  const featureFlags = featureFlagsService.getFeatureFlags();
  const featureFlag = featureFlags.find(
    (featureFlag) => featureFlag.key === key,
  );
  return !!featureFlag?.enabled;
}

export function checkEnabledFeatureFlags(keys: string[]) {
  return keys.every((flag) => checkEnabledFeatureFlag(flag));
}

export const getUserRoles = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return [];
  if (!Array.isArray(userInfo.roles)) return [];

  return userInfo.roles;
};

export const checkRolesMatchWithUserRoles = (roles: string[]) => {
  const userRoles = getUserRoles();
  return Array.isArray(roles) && intersection(roles, userRoles).length !== 0;
};
